__turbopack_context__.v({
  "bounceIn": "y59nHW_bounceIn",
  "fadeIn": "y59nHW_fadeIn",
  "float1": "y59nHW_float1",
  "float2": "y59nHW_float2",
});
